import { LogoMark } from "./Logo";

export const Marquee = ({ items }) => {
  const row = [...items, ...items];
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-[#262b38] py-8 sm:py-10 select-none">
      <div className="marquee-track flex w-max items-center">
        {row.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className={`font-display font-bold text-5xl sm:text-7xl lg:text-8xl tracking-tight px-8 ${i % 2 ? "outline-text" : "text-[#f4f5f7]"}`}>
              {t}
            </span>
            <LogoMark className="w-8 h-8 sm:w-10 sm:h-10 text-[#3a4152]" />
          </span>
        ))}
      </div>
    </div>
  );
};
